/** @internal */
export enum UserStorageKey {
    anonymousId = 'id',
    locale = 'll',
    timeZone = 'tz',
    token = 't',
    externalId = 'xid',
    isSubscribed = 's',
    subscriberStatus = 'ss',
    DISMISSED_STATUS_EXPIRATION = 'dse',
    isInDeletedState = 'udr',
    isOptedOut = 'oo',
    IS_USER_IN_SOFT_UNSUBSCRIBE_STATE = 'sunsub',
    reportedSubscriptionFingerprint = 'rsf',
    lastNotificationPermission = 'lnp',
}

/** @internal */
export const LegacyStorageKey = {
    [UserStorageKey.anonymousId]: 'pushly.user_puuid',
    [UserStorageKey.token]: '_pntx',
    [UserStorageKey.externalId]: '_pnxd',
    [UserStorageKey.subscriberStatus]: '_pnss',
    [UserStorageKey.isInDeletedState]: '_pnudr',
    [UserStorageKey.DISMISSED_STATUS_EXPIRATION]: '_pnpdm',
} as const

/** @internal */
export enum SettingsStorageKey {
    logLevel = 'log',
    eventsCache = 'ev',
    /**
     * Events that must reach the server even after tracking halts. Kept apart from
     * {@link eventsCache}, which every tab overwrites whole from its own memory, so that a tab
     * that never saw one of these cannot erase it.
     */
    writeAheadEvents = 'wa',
    /**
     * Domain config on its own. Superseded by {@link DOMAIN_SETTINGS} as the SDK's cache
     * entry, but still written on every hydrate: an installed service worker keeps running
     * its own code long after an SDK release and reads this key to recover the VAPID key.
     */
    domainConfig = 'd',
    /** Domain config and prompts together - the SDK's cache entry. */
    DOMAIN_SETTINGS = 'ds',

    /**
     * Retired: prompts are cached as part of {@link DOMAIN_SETTINGS}. Nothing reads or writes
     * this any more, and clients still holding it drop it when their tab closes.
     *
     * Kept listed so the key is not handed to something with a different shape while that
     * data is still on disk somewhere.
     */
    PROMPTS_CACHE = 'p',
    PROMPTS_OCCURRENCES_MAP = 'pocm',
    PROMPTS_LAST_VIEWED = 'plv',
}

/** @internal */
export enum SessionStorageKey {
    SESSION_START = 'sxst',
    SESSION_RUNTIME = 'sxrt',
    SESSION_PAGE_VIEWS = 'sxpv',
    SESSION_PAGE_VIEW_START = 'sxpvs',
    SESSION_READY_PROMPT = 'sxrp',
    SESSION_LAST_ACTIVITY = 'ula',
    SESSION_HEARTBEAT_SESSION = 'hbs',
    SESSION_ID = 'sxid',
}
